export const dataLayerPush = (event: object) => {
    setTimeout(() => {
        dataLayer.push(event);
    });
};
